import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import "react-toastify/dist/ReactToastify.css";
import { Provider } from "react-redux";
import { GoogleOAuthProvider } from "@react-oauth/google";
import store from "./redux/store/store";

import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import "datatables.net-dt/css/dataTables.dataTables.css";
import "datatables.net";
import { SettingsProvider } from "./context/SettingsContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    {/* Live */}
    <GoogleOAuthProvider clientId="980534475790-j9v4ejne5f261jcc6ciuh35atb5301on.apps.googleusercontent.com">
      {/* Local */}
    {/* <GoogleOAuthProvider clientId="391748481173-opral4rga2sagmjn8vv46knfa3c9t64r.apps.googleusercontent.com"> */}
      {"  "}
      <Provider store={store}>
        <SettingsProvider>
        <App />
        </SettingsProvider>
      </Provider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
